import { RootState } from "../../app/state";
import { fileAdapter } from "./fileState";
import { createSelector } from "@reduxjs/toolkit";

const selectRoot = (state: RootState) => state;
export const selectFileSlice = (state: RootState) => state.fileSlice;

export const allAdapterSelectors = fileAdapter.getSelectors(selectFileSlice);

export const selectAllFiles = allAdapterSelectors.selectAll;
export const selectFileById = allAdapterSelectors.selectById;

export const selectCurrentFileId = createSelector(
  selectFileSlice,
  (state) => state.selectedFileId
);

export const selectCurrentFile = createSelector(
  selectRoot,
  selectCurrentFileId,
  (root, currentFileId) => currentFileId ? selectFileById(root, currentFileId) : null
);